<template>
  <v-container id="home_menu" fluid tag="section">
    <div>
      <Alert_personnel_report_rounds/>
        <Alert />
      <Alert_salary_gov v-if="period_college_80105.period_college_enable==='1' || period_college_80105.period_college_enable === 1" />
    
      
    </div>

    <v-alert
      icon="mdi-shield-account"
      prominent
      type="info"
      border="left"
      colored-border
      elevation="3"
      class="mb-6"
    >
      <v-row align="center" justify="center">
        <v-col cols="12" md="6" class="d-flex align-center">
          <v-avatar size="64" color="blue lighten-4" class="mr-4">
            <v-icon color="primary" size="40">mdi-account-circle</v-icon>
          </v-avatar>
          <div>
            <h2 class="mb-1 font-weight-bold blue--text">
              ผู้ใช้งานระบบ : {{ user.user_ID || "-" }}
            </h2>
            <h3 class="mb-1">
              <span class="grey--text">ชื่อผู้ใช้งาน :</span>
              <span class="font-weight-bold"
                >{{ user.user_firstname }} {{ user.user_lastname || "" }}</span
              >
            </h3>
            <h3>
              <span class="grey--text">สถานะ :</span>
              <v-chip
                color="success"
                text-color="white"
                class="ml-1"
                v-if="user.user_status === 'active'"
              >
                กำลังใช้งาน
              </v-chip>
              <v-chip color="grey" text-color="white" class="ml-1" v-else>
                {{ user.user_status || "-" }}
              </v-chip>
            </h3>
          </div>
        </v-col>
      </v-row>
    </v-alert>
    <div class="text-center pa-2">
      <!--   <v-btn rounded outlined color="warning" class="mr-1" href="#userlogin"
        >ผู้ใช้งานระบบ</v-btn
      >
      <v-btn rounded outlined color="error" class="mr-1" href="#college"
        >ข้อมูลวิทยาลัย</v-btn
      >
      <v-btn rounded outlined color="deep-purple accent-4" class="mr-1" href="#personnel"
        >ข้อมูลบุคคล</v-btn
      > -->
      <v-btn rounded outlined color="info darken-2" class="mr-1" href="#t38MV"
        >ย้าย บุคลากรอื่น 38 ค.(2)</v-btn
      >

      <v-btn
        rounded
        outlined
        color="green darken-4"
        class="mr-1"
        href="#condition"
        >เงือนไขสาขาวิชารับย้าย</v-btn
      >
      <v-btn rounded outlined color="info" class="mr-1" href="#teacherMV"
        >ย้ายครู</v-btn
      >
      <v-btn rounded outlined color="brown" class="mr-1" href="#manageMV"
        >ย้ายผู้บริหาร</v-btn
      >
      <v-btn
        rounded
        outlined
        color="orange darken-4"
        class="mr-1"
        href="#manpower"
        >ระบบอัตรากำลัง</v-btn
      >
      <v-btn
        rounded
        outlined
        color="lime darken-4"
        class="mr-1"
        href="#assisstant"
        >ครูผู้ช่วย</v-btn
      >

      <v-btn
        rounded
        outlined
        color="purple darken-4"
        class="mr-1"
        href="#gov_em"
        >พนักงานราชการ</v-btn
      >


    </div>
    <v-row no-gutters align="stretch">
      <v-col cols="12" md="6" class="pa-1 flex-card">
        <v-alert
          border="left"
          colored-border
          type="error"
          elevation="2"
          icon="mdi-account-cog"
          id="userlogin"
        >
          <v-card-title>ผู้ใช้งานระบบ</v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in user_system_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>
      <v-col cols="12" md="6" class="pa-1 flex-card">
        <v-alert
          border="left"
          colored-border
          type="error"
          elevation="2"
          icon="mdi-account-cog"
          id="college"
        >
          <v-card-title>ข้อมูลวิทยาลัย</v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in college_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>
      <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          color="deep-purple accent-4"
          elevation="2"
          icon="mdi-account-details"
          id="personnel"
        >
          <v-card-title>ข้อมูลงานบุคคล</v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in user_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>

       <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          color="orange darken-4"
          elevation="2"
          icon="mdi-human"
          id="manpower"
          ><v-card-title>ระบบอัตรากำลัง</v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in human_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>


        <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          color="yellow accent-4"
          elevation="2"
          icon="mdi-human-male-male"
          id="assisstant"
        >
          <v-card-title
            >ระบบครูผู้ช่วย

            <v-spacer></v-spacer>
            <v-btn text color="red" @click="VideoDialogAssessmentDev()">
              <v-icon large color="red">mdi-video</v-icon>
            </v-btn>
          </v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in prepare_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>



   

    

      <!--  <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          type="info"
          elevation="2"
          icon="mdi-account-convert"
          id="teacherMV"
        >
          <v-card-title>รายงานการเสนอย้าย สายการสอน (ครู)</v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in movement_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col> -->

      <!--   <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          elevation="2"
          icon="mdi-account-convert"
          id="manageMV"
        >
          <v-card-title
            >รายงานผู้บริหารเสนอย้าย
            <h3 class="red--text">ขอย้ายเข้า</h3>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="VideoDialogManageMove()">
              <v-icon large color="red">mdi-video</v-icon>
            </v-btn>
          </v-card-title>

          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in movementmanageout_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>
 -->

      <!-- <v-col
        cols="12"
        md="12"
        class="pa-1"      
      >
        <v-alert
          border="left"
          colored-border
          elevation="2"
          icon="mdi-account-convert"
        >
          <v-card-title
            >รายงานผู้บริหารเสนอย้าย
            <h3 class="red--text">ขอย้ายออก</h3>
          </v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in movementmanagein_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col> -->
      <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          elevation="2"
          icon="mdi-account-convert"
          id="assisstant_dutyDirector"
        >
          <v-card-title
            >คัดเลือก ตำแหน่ง รองผู้อำนวยการวิทยาลัย
            <v-spacer></v-spacer>
          </v-card-title>

          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in sedirector_app_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>

     
       <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          color="green darken-4"
          elevation="2"
          icon="mdi-source-branch"
          id="condition"
        >
          <v-card-title
            >เงือนไขสาขาวิชา ตำแหน่ง ข้าราชการครู

            <v-spacer></v-spacer>
            <v-btn text color="red" @click="VideoDialogConditionB()">
              <v-icon large color="red">mdi-video</v-icon>
            </v-btn>
          </v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in condition_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>


         <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          type="info"
          elevation="2"
          icon="mdi-account-convert"
          id="t38MV"
        >
          <v-card-title
            >รายงานการเสนอย้าย บุคลากรทางการศึกษาอื่นตามมาตรา 38
            ค.(2)</v-card-title
          >
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in movement38_items"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>
      
    

      <v-col cols="12" md="12" class="pa-1">
        <v-alert
          border="left"
          colored-border
          color="#56006BFF"
          elevation="2"
          icon="mdi-human-male-male"
          id="gov_em"
        >
          <v-card-title>พนักงานราชการ </v-card-title>
          <v-list>
            <v-list-item-group>
              <v-list-item
                v-for="item in govem_item"
                :key="item.i"
                :to="item.to"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-alert>
      </v-col>


     
    </v-row>

    <!-- V-model userdialog -->
    <v-layout row justify-center>
      <v-dialog v-model="adduserdialog" persistent max-width="80%">
        <v-card class="mx-auto pa-6" elevation="2">
          <base-material-card
            color="yellow"
            icon="mdi-clipboard-text"
            title="เปลี่ยนรหัสผ่าน"
            class="px-5 py-3 text_google"
            elevation="2"
          >
          </base-material-card>
          <v-card-text>
            <v-form ref="userform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    {{ user.user_name }} {{ user.user_firstname
                    }}{{ user.user_lastname }}
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Password"
                      v-model="user.user_password"
                      type="password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6>
                    <v-text-field
                      outlined
                      label="Confirm Password"
                      v-model="user.user_confirmpassword"
                      type="password"
                      required
                      :rules="[v => v == user.user_password]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
              </v-container>
              <small>* จำเป็น</small>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn large @click.stop="adduserdialog = false" rounded>
              <v-icon dark>mdi-close</v-icon>ยกเลิก
            </v-btn>
            <v-btn large color="warning" @click.stop="userSubmit()" rounded>
              <v-icon dark>mdi-pencil</v-icon>&nbsp;แก้ไข
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeManageMovement"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/Tg9DjFm6SDM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeManageMovement = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeConditionbranch"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/iVZy90tWSZg"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeConditionbranch = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Video Dialog -->
    <v-layout>
      <v-dialog
        v-model="VideoDialogYoutubeAssessmentDevTeach"
        persistent
        max-width="80%"
      >
        <v-card>
          <v-card-text>
            <v-card>
              <v-card-text>
                <iframe
                  width="100%"
                  height="600px"
                  src="https://www.youtube.com/embed/IuTKn-M-KGY"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              large
              rounded
              @click.stop="VideoDialogYoutubeAssessmentDevTeach = false"
              ><v-icon dark>mdi-close</v-icon>ยกเลิก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </v-container>
</template>

<script>
import Alert from "../../components/college/alert.vue";
import Alert_assesment_teach from "../../components/college/alert_assesment_teach.vue";
import Alert_personnel_report_rounds from "../../components/college/alert_personnel_report_rounds.vue";
import Alert_salary_gov from "../../components/gov_salary/alert_salary_gov.vue";
export default {
  components: { Alert, Alert_assesment_teach ,Alert_salary_gov,Alert_personnel_report_rounds},
  data() {
    return {
      ApiKey: "HRvec2021",
      user: [],
      periods: [],
      adduserdialog: false,
      VideoDialogYoutubeManageMovement: false,
      VideoDialogYoutubeConditionbranch: false,
      VideoDialogYoutubeAssessmentDevTeach: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      user_system_items: [
        {
          text: "ข้อมูลผู้ใช้งานระบบ ข้าราชการครูและบุคลาการทางการศึกษา",
          icon: "mdi-account-arrow-right",
          to: "/college/personnel"
        }
      ],

      sedirector_app_items: [
        {
          text: "คัดเลือก ตำแหน่งรองผู้อำนวยการ",
          icon: "mdi-information",
          to: "/college/sedirector_app"
        },
        {
          text: "รับรายงานตัว ตำแหน่ง รองผู้อำนวยการ",
          icon: "mdi-account-star",
          to: "/college/sedirector_app_report"
        },
      ],

      college_items: [
        {
          text: "ข้อมูลรายละเอียดวิทยาลัย",
          icon: "mdi-information",
          to: "/college/collegeinfo"
        }
      ],

      user_items: [
        {
          text: "ข้อมูลข้าราชการครูและบุคลากรทางการศึกษา (จากส่วนกลาง)",
          icon: "mdi-account",
          to: "/college/personnel_tem"
        },
        {
          text:
            "ข้อมูลข้าราชการครูและบุคลากรทางการศึกษา (วิทยาลัย) งานอัตรากำลัง",
          icon: "mdi-account-settings",
          to: "/college/personnel_etc"
        },
        {
          text: "ข้อมูลคุณวุฒิการศึกษา",
          icon: "mdi-school",
          to: "/college/personnel_education"
        },
        {
          text: "คัดเลือก/แข่งขัน บุคลากร",
          icon: "mdi-account-search",
          to: "/college/temporarycollegeemreg"
        },

        {
          text: "รายงานการเดินทางราชการ",
          icon: "mdi-account-search",
          to: "/college/tripReport"
        }
      ],
      movement_items: [
        {
          text: "สายการสอนประสงค์ย้ายออก",
          icon: "mdi-account-circle",
          to: "/college/transference_personnel"
        },
        {
          text: "สายการสอนประสงค์ย้ายเข้า",
          icon: "mdi-account-circle",
          to: "/college/transference_personnel_movein"
        }
      ],

      movement38_items: [
        {
          text: "ประสงค์ย้ายออก",
          icon: "mdi-account-circle",
          to: "/college/transference_personnel_38"
        },
        {
          text: "ประสงค์ย้ายเข้า",
          icon: "mdi-account-circle",
          to: "/college/transference_personnel_movein_38"
        }
      ],

      movementmanagein_items: [
        {
          text: "สายบริหารในวิทยาลัยยืนย้าย",
          icon: "mdi-account-circle",
          to: "/college/transference_manage"
        }
      ],

      movementmanageout_items: [
        {
          text: "สายบริหารวิทยาลัยอื่นประสงค์ย้าย",
          icon: "mdi-account-circle",
          to: "/college/transference_manage_location"
        }
      ],

      condition_items: [
        {
          text: "ข้อมูลเงือนไขสาขาวิชาเอก",
          icon: "mdi-source-branch",
          to: "/college/conditions_branch"
        },
        {
          text: "ประวัติข้อมูลเงืนอไขสาขาวิชาเอก",
          icon: "mdi-source-branch",
          to: "/college/history_conditions"
        }
      ],

      human_items: [
        {
          text: "กำหนดสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง",
          icon: "mdi-account-multiple",
          to: "/college/man_power_j"
        },
        {
          text: "ข้อมูลทั่วไป",
          icon: "mdi-account-multiple",
          to: "/college/rate_workforce_g"
        },
        {
          text: "ข้อมูลอัตรากำลังวิทยาลัย",
          icon: "mdi-account-multiple",
          to: "/college/rate_workforce"
        },
        {
          text: "ข้อมูลอัตรากำลังวิทยาลัยสรุป",
          icon: "mdi-account-multiple",
          to: "/college/rate_workforce_pro"
        }
      ],

      prepare_items: [
        {
          text: "รับรายงานตัวครูผู้ช่วย",
          icon: "mdi-account-star",
          to: "/college/manage_assistant_teacher"
        },
        {
          text: "การแต่งตั้งคณะกรรมการประเมิน",
          icon: "mdi-account-star",
          to: "/college/assistantcommitteequalified"
        },
        {
          text: "รายงานผลการประเมิน",
          icon: "mdi-account-star",
          to: "/college/assistant_teacher"
        }
      ],
      sedirector_items: [
        
        {
          text: "รับรายงานตัว ตำแหน่ง ครูผู้ช่วย",
          icon: "mdi-account-star",
          to: "/college/manage_assistant_teacher"
        }
      ],
      govem_item: [
        {
          text: "รับรายงานตัว กรณี ย้าย",
          icon: "mdi-account-star",
          to: "/college/gov_em/receive_govem"
        },

         {
          text: "ข้อมูลพนักงานราชการ กรอบอัตรากำลัง",
          icon: "mdi-account-star",
          to: "/college/gov_em/government_employee"
        },


        {
          text: "ข้อมูลพนักงานราชการ และสัญญา",
          icon: "mdi-account-star",
          to: "/college/gov_em/personnel_govem"
        },

         {
          text: "รายงานผลการประเมินการปฏิบัติงาน",
          icon: "mdi-account-star",
          to: "/college/gov_em/assessment_govem"
        },


        {
          text: "การคำนวณค่าตอบแทนพนักงานราชการ",
          icon: "mdi-account-star",
          to: "/college/gov_em/cal_compensation"
        }
      ],
      period_college_80105:[],
    };
  },

  async mounted() {
    await this.getuser();
    await this.period_collegeQuery();
  },

  methods: {
    async period_collegeQuery(){
      let result = await this.$http.post('period_college.php',{
        ApiKey:this.ApiKey,
        period_college_id:"80105"
      })
      this.period_college_80105=result.data
    },
    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    async getuser() {
      let result;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      result = await this.$http.post("admin.php", {
        user_name: userSession.user_name,
        ApiKey: "HRvec2021"
      });
      this.user = result.data;
    },

    async VideoDialogAssessmentDev() {
      this.VideoDialogYoutubeAssessmentDevTeach = true;
    },

    async VideoDialogConditionB() {
      this.VideoDialogYoutubeConditionbranch = true;
    },
    async VideoDialogManageMove() {
      this.VideoDialogYoutubeManageMovement = true;
    },

    async userUpdate() {
      this.adduserdialog = true;
    },

    async userSubmit() {
      if (this.$refs.userform.validate()) {
        this.user.ApiKey = this.ApiKey;
        let result;
        result = await this.$http.post("user.update_password.php", this.user);
        if (result.status == "200") {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.adduserdialog = false;
      }
    }
  }
};
</script>
<style>
.listcontent {
  background-color: #750606;
  border-bottom: 3px solid #d68822;
  height: 100px;
}
</style>
